import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { EMAIL, EMAIL_LINK, PHONE } from "@/data/site";

const SECTIONS = [
  {
    title: "1. About These Terms",
    body: [
      "These Terms & Conditions govern your use of the Sage Auto Group website and the accident management services we provide. By using this website or engaging our services, you accept these terms.",
      "Sage Auto Group is an accident management company operating in the United Kingdom. We coordinate recovery, storage, replacement vehicles, repairs and insurance liaison through a trusted network of independent partners.",
    ],
  },
  {
    title: "2. Our Services",
    body: [
      "Sage Auto Group acts as your accident management coordinator. Recovery, repair, storage, vehicle hire and legal services are delivered by carefully selected third-party partners. While we manage the process end-to-end and hold our partners to strict standards, those services are performed under the terms of the relevant partner where applicable.",
      "Emergency accident assistance is offered 24 hours, subject to partner availability. Our office operates Monday to Friday 8:00 AM – 6:00 PM, Saturday 9:00 AM – 1:00 PM, and Sunday by appointment.",
    ],
  },
  {
    title: "3. Non-Fault Claims & Costs",
    body: [
      "Where an accident was not your fault, the reasonable costs of our services are typically recovered from the at-fault party's insurer. Before any chargeable service begins, we will explain how costs are handled so you can make an informed decision.",
      "You are responsible for providing accurate information about the accident. Providing false or misleading information may result in the withdrawal of services and recovery of any costs incurred.",
    ],
  },
  {
    title: "4. Your Responsibilities",
    body: [
      "You agree to provide accurate and complete information, to cooperate with reasonable requests during your claim, and to comply with any obligations you owe to your own insurer, including notifying them of the accident where required by your policy.",
    ],
  },
  {
    title: "5. Website Use",
    body: [
      "The content of this website is provided for general information only and does not constitute legal advice. We take reasonable care to keep information accurate and up to date, but we make no warranties that the website will be uninterrupted or error-free.",
      "All content, branding and design on this website are the property of Sage Auto Group and may not be reproduced without written permission.",
    ],
  },
  {
    title: "6. Limitation of Liability",
    body: [
      "Nothing in these terms excludes or limits liability where it would be unlawful to do so. Subject to that, Sage Auto Group is not liable for indirect or consequential losses arising from the use of this website, or for delays caused by events beyond our reasonable control, including the availability of third-party partners.",
    ],
  },
  {
    title: "7. Governing Law",
    body: [
      "These terms are governed by the laws of England and Wales, and any disputes will be subject to the exclusive jurisdiction of the courts of England and Wales.",
    ],
  },
  {
    title: "8. Contact",
    body: [
      `For any questions about these Terms & Conditions, contact us at ${EMAIL} or call ${PHONE}.`,
      "These terms were last updated in July 2026.",
    ],
  },
];

const Terms = () => (
  <div data-testid="terms-page">
    <PageHero
      testId="terms-hero"
      kicker="Legal"
      titleLines={["Terms & Conditions"]}
      description="The terms that govern the use of this website and the services Sage Auto Group provides."
    />
    <section className="mx-auto max-w-3xl px-6 py-24 md:px-10 md:py-32">
      {SECTIONS.map((section, i) => (
        <Reveal key={section.title} delay={0.02 * i}>
          <div className="border-b border-white/10 py-10" data-testid={`terms-section-${i + 1}`}>
            <h2 className="font-serif text-2xl text-white">{section.title}</h2>
            {section.body.map((p, j) => (
              <p key={j} className="mt-4 text-base leading-relaxed text-zinc-400">{p}</p>
            ))}
          </div>
        </Reveal>
      ))}
      <Reveal>
        <p className="mt-10 text-sm text-zinc-500">
          Questions about these terms? Email us at{" "}
          <a href={EMAIL_LINK} data-testid="terms-email-link" className="text-gold transition-colors duration-300 hover:text-gold-hover">
            {EMAIL}
          </a>
          .
        </p>
      </Reveal>
    </section>
  </div>
);

export default Terms;
